$('[data-toggle="popover"]').popover();
$('.popover-dismiss').popover({
    trigger: 'focus',
});

$(document).tooltip({
    selector: '[data-toggle="tooltip"]'
});
